import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('@/layout/MainLayout.vue'),
    children: [
      { path: '', name: 'Home', component: () => import('@/views/home/index.vue'), meta: { title: '首页' } },
      { path: 'services', name: 'Services', component: () => import('@/views/services/index.vue'), meta: { title: '服务', requiresAdmin: true } },
      { path: 'articles', name: 'Articles', component: () => import('@/views/articles/index.vue'), meta: { title: '文章' } },
      { path: 'articles/:noteId', name: 'ArticleDetail', component: () => import('@/views/articles/detail.vue'), meta: { title: '文章详情' } },
      { path: 'profile', name: 'Profile', component: () => import('@/views/profile/index.vue'), meta: { title: '个人资料', requiresAuth: true } },
    ],
  },
  {
    path: '/auth',
    component: () => import('@/layout/AuthLayout.vue'),
    children: [
      { path: 'login', name: 'Login', component: () => import('@/views/auth/login.vue'), meta: { title: '登录', guestOnly: true } },
      { path: 'register', name: 'Register', component: () => import('@/views/auth/register.vue'), meta: { title: '注册', guestOnly: true } },
    ],
  },
]

export default routes
